import { render, staticRenderFns } from "./UserTitle.vue?vue&type=template&id=f2eee1e4"
import script from "./UserTitle.vue?vue&type=script&lang=js"
export * from "./UserTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports